import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'sham-i-Settings',
  standalone: true,
  templateUrl: '../../assets/Settings.svg',
  encapsulation: ViewEncapsulation.None
})
export class ShamSettingsIcon {}
